// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ValuedMessage, ValuedMessageT, verifyValuedMessage } from "../ln2/valued-message";
import { NodeId, NodeIdT, verifyNodeId } from "./node-id";

/**
 * Map a received event (matched by its `EventType`) to an LN2 message. The
 * selected event fields are available for templating downstream.
 */
export class EventToMessageEntry implements flatbuffers.IUnpackableObject<EventToMessageEntryT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): EventToMessageEntry {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsEventToMessageEntry(
    bb: flatbuffers.ByteBuffer,
    obj?: EventToMessageEntry,
  ): EventToMessageEntry {
    return (obj || new EventToMessageEntry()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsEventToMessageEntry(
    bb: flatbuffers.ByteBuffer,
    obj?: EventToMessageEntry,
  ): EventToMessageEntry {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new EventToMessageEntry()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  /**
   * Event type that triggers this message.
   */
  eventTypeId(obj?: NodeId): NodeId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new NodeId()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  value(obj?: ValuedMessage): ValuedMessage | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new ValuedMessage()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startEventToMessageEntry(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addEventTypeId(builder: flatbuffers.Builder, eventTypeIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, eventTypeIdOffset, 0);
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, valueOffset, 0);
  }

  static endEventToMessageEntry(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // event_type_id
    builder.requiredField(offset, 6); // value
    return offset;
  }

  unpack(): EventToMessageEntryT {
    return new EventToMessageEntryT(
      this.eventTypeId() !== null ? this.eventTypeId()!.unpack() : null,
      this.value() !== null ? this.value()!.unpack() : null,
    );
  }

  unpackTo(_o: EventToMessageEntryT): void {
    _o.eventTypeId = this.eventTypeId() !== null ? this.eventTypeId()!.unpack() : null;
    _o.value = this.value() !== null ? this.value()!.unpack() : null;
  }

  unpackFields(...fields: string[]): EventToMessageEntryT {
    const t = new EventToMessageEntryT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("event_type_id")) {
      t.eventTypeId = this.eventTypeId() !== null ? this.eventTypeId()!.unpack() : null;
    }
    if (fieldSet.has("value")) {
      t.value = this.value() !== null ? this.value()!.unpack() : null;
    }
    return t;
  }
}

export class EventToMessageEntryT implements flatbuffers.IGeneratedObject {
  constructor(
    public eventTypeId: NodeIdT | null = null,
    public value: ValuedMessageT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.eventTypeId === null || this.eventTypeId === undefined) {
      throw new Error('Required field "event_type_id" is not set');
    }
    if (this.value === null || this.value === undefined) {
      throw new Error('Required field "value" is not set');
    }
    const eventTypeId = this.eventTypeId !== null ? this.eventTypeId!.pack(builder) : 0;
    const value = this.value !== null ? this.value!.pack(builder) : 0;

    EventToMessageEntry.startEventToMessageEntry(builder);
    EventToMessageEntry.addEventTypeId(builder, eventTypeId);
    EventToMessageEntry.addValue(builder, value);

    return EventToMessageEntry.endEventToMessageEntry(builder);
  }

  clone(): EventToMessageEntryT {
    const obj = new EventToMessageEntryT();
    obj.eventTypeId = this.eventTypeId !== null ? this.eventTypeId!.clone() : null;
    obj.value = this.value !== null ? this.value!.clone() : null;
    return obj;
  }

  equals(other: EventToMessageEntryT): boolean {
    if (this.eventTypeId !== null && other.eventTypeId !== null) {
      if (!this.eventTypeId!.equals(other.eventTypeId!)) return false;
    } else if (this.eventTypeId !== other.eventTypeId) return false;
    if (this.value !== null && other.value !== null) {
      if (!this.value!.equals(other.value!)) return false;
    } else if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyEventToMessageEntry(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyNodeId(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "event_type_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyValuedMessage(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "value");
  } finally {
    verifier.popDepth();
  }
}
